import { AttachmentTile as AttachmentTileBase } from '@components/AttachmentTile'
import AttachmentTileOverlay from '@components/AttachmentTileOverlay'

import useConversationContainer from '@hooks/useConversationContainer'

import type { AttachmentModel } from '@models/types'

import type { UseProviderCampaignMediaPayload } from '../../hooks/useProviderCampaignMedia'

interface AttachmentTileProps {
  attachment: AttachmentModel,
  index: number,
  isSelected: boolean,
  orderItemPayload: UseProviderCampaignMediaPayload,
}

const AttachmentTile = (props: AttachmentTileProps) => {
  const {
    attachment, index, isSelected, orderItemPayload,
  } = props

  const {
    callbacks: {
      selectAttachment,
    },
  } = orderItemPayload

  const { hasFilteredComments } = useConversationContainer({
    // @ts-expect-error TS2740
    conversation: { subject_id: attachment.id, subject_type: 'Attachment' },
    performHttpRequests: !!attachment.id,
  })

  return (
    <AttachmentTileBase
      attachment={attachment}
      callbacks={{ selectAttachment: () => selectAttachment(index) }}
      key={attachment.id}
      isSelected={isSelected}
    >
      <AttachmentTileOverlay
        attachment={attachment}
        hasFilteredComments={hasFilteredComments}
        key={attachment.id}
      />
    </AttachmentTileBase>
  )
}

export default AttachmentTile
